import styled from '@emotion/styled'

import { Space } from '../space'
import { Typography } from '../typography'

export type ValidationMessageProps = {
  errors: { [key: string]: string }
  excludeFieldNames?: string[]
  // Shows all errors if no field name is provided
  fieldName?: string
}

export const StyledValidationMessage = styled.div`
  color: var(--Warn);
`

export function ValidationMessage({
  errors,
  excludeFieldNames,
  fieldName
}: ValidationMessageProps) {
  const renderMessage = (field: string) => (
    <StyledValidationMessage
      key={`${field}_validation_message`}
      data-testid={`${field}_error`}
      role="alert"
    >
      <Space mt={3}>
        <Typography fontSize="13px" variant="b3">
          {errors[field]}
        </Typography>
      </Space>
    </StyledValidationMessage>
  )

  return (
    <>
      {fieldName && errors[fieldName] && renderMessage(fieldName)}
      {!fieldName &&
        errors &&
        Object.keys(errors)
          .filter(key => (excludeFieldNames ? !excludeFieldNames.includes(key) : true))
          .map(anyError => renderMessage(anyError))}
    </>
  )
}
